// extracted by mini-css-extract-plugin
export var wrapper = "Lead-module--wrapper--1YXBr";
export var leadBasicInfo = "Lead-module--lead-basic-info--2Cbeh";
export var leadImage = "Lead-module--lead-image--14vqv";
export var companyName = "Lead-module--company-name--1sQwf";
export var companyInfoWrapper = "Lead-module--company-info-wrapper--1bdrz";
export var tracking = "Lead-module--tracking--3kYc3";
export var text = "Lead-module--text--3yQpR";
export var leadScoreChart = "Lead-module--lead-score-chart--1eK39";
export var leadScore = "Lead-module--lead-score--2EVg1";